import styled from 'styled-components'
import {StoresMapBase} from './base'

/** Render the store map. */
export const StoresMap = styled(StoresMapBase)`
  height: 100%;
  min-height: 300px;
`
